/* src/app/components/input-file-info/input-file-info.component.scss */
.edit {
  display: inline-flex;
  width: 100%;
  align-items: center;
  justify-content: space-between;
  opacity: 1;
  border: 0.0625rem solid rgba(46, 46, 56, 0.08);
  font-size: 0.75rem;
  line-height: 1.25rem;
  font-weight: 300;
  color: rgba(114, 114, 127, 0.32);
  margin-top: 0;
}
.edit.hidden {
  opacity: 0;
  border: none;
  position: absolute;
  left: -99999;
}
.edit .btn-edit {
  font-size: 0.875rem;
  line-height: 1.25rem;
  font-weight: 400;
  color: #155cb4;
}
.info {
  padding: 0.75rem 1.25rem;
  border: 1px solid rgba(46, 46, 56, 0.08);
  margin-top: 1.75rem;
  margin-bottom: 0;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.info .container-upload {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
}
.info .container-upload .container-info {
  margin-left: 1.25rem;
  margin-right: 0.625rem;
  min-width: 0;
  flex: 1;
}
.info .container-upload .container-info .container-title {
  display: flex;
  align-items: center;
  flex: 1;
}
.info .container-upload .container-info .container-title .backgroud-icon {
  width: 0.9375rem;
  height: 0.9375rem;
  flex: 0 0 0.9375rem;
  background-color: rgba(46, 46, 56, 0.32);
  border-radius: 100%;
  padding: 0;
  border: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  position: relative;
}
.info .container-upload .container-info .container-title .backgroud-icon:after,
.info .container-upload .container-info .container-title .backgroud-icon::before {
  content: "";
  display: block;
  position: absolute;
  top: 0.4375rem;
  width: 0.5625rem;
  height: 0.0625rem;
  border-radius: 6.25rem;
  background-color: #ffffff;
}
.info .container-upload .container-info .container-title .backgroud-icon::before {
  transform: rotate(45deg);
  left: 0.1875rem;
}
.info .container-upload .container-info .container-title .backgroud-icon::after {
  transform: rotate(-45deg);
  right: 0.1875rem;
}
.info .container-upload .container-info .title {
  font-size: 0.875rem;
  line-height: 1.25rem;
  font-weight: 300;
  color: #2e2e38;
  margin: 0 0.25rem 0 0;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.info .container-upload .container-info .size {
  display: block;
  font-size: 0.625rem;
  line-height: 0.75rem;
  font-weight: 300;
  color: #72727f;
}
.info .other-info {
  display: flex;
  align-items: center;
}
.info .other-info .done-icon,
.info .other-info .error-icon {
  font-size: 1.25rem;
  line-height: 1.25rem;
  margin: 0.125rem 0 0 1.375rem;
}
.info .other-info .done-icon {
  color: #168736;
}
.info .other-info .error-icon {
  color: #89251c;
}
.info .other-info .custom-badge {
  display: block;
  border-radius: 0.75rem;
  background-color: #747480;
  padding: 0.125rem 0.375rem;
  font-size: 0.75rem;
  line-height: 1rem;
  color: #ffffff;
}
.info .progress {
  height: 0.25rem;
}
.error-message-container {
  margin: 0.125rem 0 0 1rem;
}
.error-message-container small {
  font-size: 0.75rem;
  line-height: 0.875rem;
  font-weight: 300;
  color: #89251c;
}
.container {
  padding: 1rem 1rem;
  border: 1px solid rgba(46, 46, 56, 0.08);
  border-top: none;
}
.container .config {
  display: flex;
  align-items: center;
  margin-top: 0.5rem;
}
.container .config:first-child {
  margin-top: 0;
}
.container .config .name {
  font-size: 0.875rem;
  line-height: 1.25rem;
  color: rgba(46, 46, 56, 0.64);
  margin: 0;
}
.container .config .name-container {
  padding: 0.875rem 0;
  width: 100%;
}
.container .config .select-container {
  padding: 0;
}
/*# sourceMappingURL=input-file-info.component.css.map */
